 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Business Class
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryBusClsFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryBusClsFilterForm"
                            v-model="filtersBusCls.busCls"
                            :label="filtersBusClsLabel.busCls"
                            :error-messages="errors.collect('filterBusCls')"
                            data-vv-name="filterBusCls"
                            :data-vv-as="filtersBusClsLabel.busCls"
                            v-validate="'entry|max:4'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryBusClsFilterForm"
                            v-model="filtersBusCls.busClsDesc"
                            :label="filtersBusClsLabel.busClsDesc"
                            :error-messages="errors.collect('filterBusClsDesc')"
                            data-vv-name="filterBusClsDesc"
                            :data-vv-as="filtersBusClsLabel.busClsDesc"
                            v-validate="'entry|max:40'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearBusClsFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doBusClsFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-2">
        <v-data-table
          :headers="busClsHeaders"
          :items="busClsItems"
          v-bind:options.sync="paginationBusClsByPolType"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItems"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.busCls }}</td>
              <td>{{ row.item.busClsDesc }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignBusCls(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI, filterQuery } from '@/utils/ajax'

export default {
  props: {
    polType: String
  },
  data() {
    return {
      filtersBusClsLabel: {
        busCls: 'Business Class',
        busClsDesc: 'Description'
      },
      filtersBusCls: {
        busCls: undefined,
        busClsDesc: undefined,
        polType: undefined
      },
      busClsItems: [],
      totalItems: 0,
      busClsHeaders: [
        { text: 'Business Class', align: 'left', value: 'busCls' },
        { text: 'Description', align: 'left', value: 'busClsDesc' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationBusClsByPolType: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  watch: {
    'paginationBusClsByPolType': function (value) {
      this.fetchBusClsByPolTypeData()
    }
  },
  mounted() {
    this.doClearBusClsFilters()
  },
  methods: {
    closeDialog() {
      this.filtersBusCls.busCls = ''
      this.filtersBusCls.busClsDesc = ''
      this.$emit('close')
    },
    doClearBusClsFilters() {
      this.filtersBusCls.busCls = ''
      this.filtersBusCls.busClsDesc = ''
      this.fetchBusClsByPolTypeData()
    },
    doBusClsFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryBusClsFilterForm').then((result) => {
        if (result) {
          this.paginationBusClsByPolType.page = 1
          this.fetchBusClsByPolTypeData()
        }
      })
    },
    assignBusCls(data) {
      this.$emit('assign-busCls', data)
      this.$emit('close')
      this.doClearBusClsFilters()
    },
    async fetchBusClsByPolTypeData() {
      const apiUrl = this.$store.state.commons.menu.polTypeClsList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationBusClsByPolType
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let massageFilters = {
            busCls: this.filtersBusCls.busCls,
            busClsDesc: this.filtersBusCls.busClsDesc,
            polType: this.polType
          }
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), massageFilters, this.paginationBusClsByPolType.sortBy, this.paginationBusClsByPolType.sortDesc)
          )
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              this.$set(this, 'busClsItems', data)
            } else {
              this.$set(this, 'busClsItems', [])
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
